import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1661316688482'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='24480'
    >
        <path
            d='M950.441 275.796v407.645c0 12.39-3.185 23.886-9.555 34.502s-15.043 18.933-26.009 24.946l-373.675 203.824c-9.908 5.655-20.699 8.492-32.375 8.492s-22.476-2.837-32.378-8.492l-373.675-203.824c-10.973-6.012-19.638-14.331-26.009-24.946-6.37-10.614-9.554-22.111-9.554-34.502v-407.645c0-14.148 4.063-27.069 12.208-38.746 8.137-11.677 18.927-19.987 32.378-24.946l373.675-135.881c7.78-2.83 15.568-4.246 23.355-4.246 7.779 0 15.567 1.417 23.353 4.246l373.675 135.881c13.442 4.959 24.233 13.27 32.375 24.946 8.137 11.677 12.208 24.598 12.208 38.746zM508.828 409.553l370.489-134.82-370.489-134.821-370.49 134.82 370.49 134.821zM542.798 868.686l339.702-185.245v-337.581l-339.702 123.675v399.153z'
            p-id='24481'
            fill='currentColor'
        ></path>
    </svg>
)

export const LocationsIcon = props => <Icon component={SVG} {...props} />
